import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 自定义样式必须在 element-ui 之后，才能覆盖组件默认样式
import './styles/index.scss'
import './permission'
import { pxToRem, toPx } from '@/utils/tool'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import mqttClient from './utils/mqtt';
Vue.config.productionTip = false
Vue.prototype.mqttClient = mqttClient;
import infiniteScroll from 'vue-infinite-scroll';
import VueLazyLoad from 'vue-lazyload'
import { setupAppLogger, logger } from '@/utils/logger'
Vue.use(infiniteScroll);
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper)
setupAppLogger(Vue, router)
Vue.use(VueLazyLoad, {
  preLoad: 1,
  error: '',
  loading: '',
  attempt: 2,
  observer: true
})
Vue.mixin({
  methods: {
    pxToRem,
    toPx
  }
})
Vue.prototype.$logger = logger
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
Vue.directive("click-audio", {
  bind(el) {
    const audioSrc = require("@/assets/source/audio/click.mp3");
    const audio = new Audio(audioSrc);

    const readBaseTransform = () => {
      const inline = (el.style.transform && el.style.transform.trim()) || "";
      if (inline) return inline;
      const computed = window.getComputedStyle(el).transform;
      return computed === "none" ? "" : computed;
    };

    const onClick = () => {
      const wasAnimating = !!el.__clickAudioResetTimer__;
      if (wasAnimating) {
        clearTimeout(el.__clickAudioResetTimer__);
        el.__clickAudioResetTimer__ = null;
      }

      el.style.transition = "none";
      // 仅打断进行中的脉冲：回到本次脉冲前的 transform，避免清空/覆盖样式表里已有的 transform
      if (
        wasAnimating &&
        Object.prototype.hasOwnProperty.call(el, "__clickAudioBaseTransform")
      ) {
        el.style.transform = el.__clickAudioBaseTransform;
      }
      void el.offsetHeight;

      const base = readBaseTransform();
      el.__clickAudioBaseTransform = base;

      audio.currentTime = 0;
      audio.play().catch(() => {});

      el.style.transition = "transform 0.2s ease";
      el.style.transform = base ? `${base} scale(0.92)` : "scale(0.92)";

      el.__clickAudioResetTimer__ = setTimeout(() => {
        el.style.transition = "transform 0.2s ease";
        el.style.transform = base;
        el.__clickAudioResetTimer__ = null;
      }, 200);
    };

    el.__clickAudioHandler__ = onClick;
    el.addEventListener("click", onClick);
  },
  unbind(el) {
    if (el.__clickAudioResetTimer__) {
      clearTimeout(el.__clickAudioResetTimer__);
      delete el.__clickAudioResetTimer__;
    }
    if (el.__clickAudioHandler__) {
      el.removeEventListener("click", el.__clickAudioHandler__);
      delete el.__clickAudioHandler__;
    }
    el.style.transition = "";
    if (Object.prototype.hasOwnProperty.call(el, "__clickAudioBaseTransform")) {
      el.style.transform = el.__clickAudioBaseTransform;
      delete el.__clickAudioBaseTransform;
    }
  },
});

